import { __decorate } from "tslib";
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { findDOMNode } from 'react-dom';
import 'react-quill/dist/quill.snow.css';
import isEqual from 'lodash/isEqual';
import isObject from 'lodash/isObject';
import omit from 'lodash/omit';
import LightBox from 'react-image-lightbox';
import QuillImageDropAndPaste from './utils/imageDropAndPaste';
import autobind from '../_util/autobind';
import RichTextViewer from './RichTextViewer';
import Toolbar from './toolbar';
let ReactQuill;
let Quill;
if (typeof window !== 'undefined') {
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    ReactQuill = require('react-quill');
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    Quill = require('react-quill').Quill;
    /**
     * 注册图片拖拽、粘贴
     */
    Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
}
let BaseEditor = class BaseEditor extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            imgOpen: false,
            images: [],
            srcIndex: 0,
        };
        this.handleOpenLightBox = (e) => {
            if (e.target.nodeName === 'IMG' && this.deltaOps) {
                e.stopPropagation();
                const src = e.target.src;
                const imgArr = [];
                this.deltaOps.forEach(item => {
                    const image = item.insert.image;
                    if (image) {
                        imgArr.push(image);
                    }
                });
                const index = imgArr.findIndex(img => img === src);
                this.setState({
                    imgOpen: true,
                    images: imgArr,
                    srcIndex: index,
                });
            }
        };
        this.saveRef = name => (ref) => {
            this[name] = ref;
            const { saveRef } = this.props;
            if (saveRef) {
                saveRef(ref);
            }
        };
    }
    setValue(value) {
        if (this.editor) {
            this.editor.getEditor().setContents(value);
        }
    }
    handleRichTextChange(_, __, ___, editor) {
        const rtDelta = editor.getContents();
        this.deltaOps = rtDelta.ops;
        const { onChange } = this.props;
        if (onChange && rtDelta && rtDelta.ops) {
            onChange(rtDelta.ops);
        }
    }
    componentDidUpdate() {
        const { value } = this.props;
        let deltaOps;
        if (!isObject(value) && this.editor) {
            deltaOps = this.editor.getEditor().clipboard.convert(value).ops;
        }
        if ('value' in this.props && !isEqual(this.deltaOps, deltaOps || value) && this.editor) {
            this.editor.getEditor().setContents(deltaOps || value);
        }
    }
    getOtherProps() {
        return omit(this.props, ['toolbar', 'className', 'defaultValue', 'onChange', 'value', 'ref']);
    }
    componentWillUnmount() {
        const thisNode = findDOMNode(this);
        if (thisNode) {
            thisNode.removeEventListener('click', this.handleOpenLightBox);
        }
    }
    componentDidMount() {
        const { autoFocus } = this.props;
        if (autoFocus && this.editor) {
            setTimeout(() => {
                this.editor.focus();
            });
        }
        const thisNode = findDOMNode(this);
        if (thisNode) {
            thisNode.addEventListener('click', this.handleOpenLightBox);
        }
    }
    blur() {
        if (this.editor) {
            this.editor.blur();
        }
    }
    renderContent() {
        const { style, className, toolbarId, toolbar, dataSet, value, mode } = this.props;
        let deltaOps;
        if (!isObject(value) && this.editor) {
            deltaOps = this.editor.getEditor().clipboard.convert(value).ops;
        }
        if (mode === 'preview') {
            return (React.createElement(RichTextViewer, { style: style, deltaOps: deltaOps || value }));
        }
        if (ReactQuill) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Toolbar, { id: toolbarId, dataSet: dataSet, toolbar: toolbar, prefixCls: className }),
                React.createElement(ReactQuill, Object.assign({}, this.getOtherProps(), { className: `${className}-quill`, defaultValue: value, ref: this.saveRef('editor'), onChange: this.handleRichTextChange, bounds: className }))));
        }
    }
    render() {
        const { imgOpen, images, srcIndex } = this.state;
        const { className } = this.props;
        const content = this.renderContent();
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: className }, content),
            imgOpen && (React.createElement(LightBox, { mainSrc: images[srcIndex], onCloseRequest: () => this.setState({ imgOpen: false }), imageTitle: "images", prevSrc: images[srcIndex - 1], nextSrc: images[srcIndex + 1], onMovePrevRequest: () => {
                    this.setState({ srcIndex: srcIndex - 1 });
                }, onMoveNextRequest: () => {
                    this.setState({ srcIndex: srcIndex + 1 });
                } }))));
    }
};
__decorate([
    autobind
], BaseEditor.prototype, "setValue", null);
__decorate([
    autobind
], BaseEditor.prototype, "handleRichTextChange", null);
__decorate([
    autobind
], BaseEditor.prototype, "renderContent", null);
BaseEditor = __decorate([
    observer
], BaseEditor);
export default BaseEditor;
